export const ACTIONS = ['create', 'update', 'delete', 'approve', 'reject', 'assign', 'unassign', 'send'] as const;

export const ACTION_BADGE: Record<string, string> = {
  create: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400',
  update: 'bg-blue-100 text-blue-700 dark:bg-blue-950/40 dark:text-blue-400',
  delete: 'bg-red-100 text-red-700 dark:bg-red-950/40 dark:text-red-400',
  approve: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400',
  reject: 'bg-red-100 text-red-700 dark:bg-red-950/40 dark:text-red-400',
};

export function formatTimestamp(iso: string) {
  return new Date(iso).toLocaleString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

export function targetTableLabel(table: string) {
  return table.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
